export default __webpack_public_path__ + "static/media/iaeCorner11c.0517131e.png";